import React from "react";
import { ReactComponent as Icon } from "../assets/Union.svg";
import "./Logo.css";

const Logo = () => {
  return (
    <div className="logo">
      <Icon className="logo-icon" />
      <h1>
        RESTRIX
      </h1>
    </div>
  );
};

export default Logo;
